<template>
  <div class="text-center">
    <v-select
      class="supporting-layers-select elevation-2"
      v-model="activeLayers"
      item-value="title"
      item-text="title"
      label="Velg støttekartlag"
      :menu-props="{
        closeOnContentClick: false,
        offsetY: true,
        disableKeys: false,
      }"
      :items="mapLayers"
      multiple
      hide-details
      outlined
      style="min-width: 200px"
      filled
      background-color="white"
      small-chips
      deletable-chips
      @input="toggleLayerVisibility"
      dense
    >
    </v-select>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "MapSupportingLayerList",
  props: {
    mapObject: Object,
  },
  data: () => {
    return {
      activeLayers: [],
    };
  },
  computed: {
    ...mapState(["kart"]),
    mapLayers: function() {
      return this.kart.kartlag;
    },
  },
  methods: {
    toggleLayerVisibility: function(item) {
      this.mapLayers.forEach((layer) => {
        let mapLayer = this.mapObject.findLayerById(layer.id);
        if (item.includes(layer.title)) {
          mapLayer.visible = true;
        } else {
          mapLayer.visible = false;
        }
      });
    },
  },
};
</script>

<style>
.supporting-layers-select .v-select__selections input {
  width: 0;
}
</style>
